module.exports = __webpack_public_path__ + "img/homeFeature1.bf78f38.svg";